export default {
	//@ts-ignore
	install(Vue) {
		Vue.mixin({
			data() {
				return {
					usdRanges: [
						'Less than $100,000',
						'$100,000 to 150,000',
						'$150,000 to 200,000',
						'$200,000 to 300,000',
						'$300,000 to 500,000',
						'$500,000 to 1,000,000',
						'$1,000,000 plus',
						'Pro Bono'
					]
				}
			},
			methods: {
				UpdateString(s: string, r: number) {
					//@ts-ignore
					if (!s || !this.$store)
						return s;

					s = s.trim();
					s = s.replace(/,/g, '');
					const split = s.split(' ');
					var suffix = split[split.length - 1];
					if (/\d+/.test(suffix)) {
						suffix = "";
					}

					var format = Intl.NumberFormat();
					if (r !== undefined)
						format = Intl.NumberFormat("lookup", { maximumFractionDigits: r });

					//@ts-ignore
					const nums = s.match(/\d+/g).map(num => this.$store.getters.currency.Symbol + format.format(num / this.$store.getters.xrate) + " " + suffix);

					//@ts-ignore
					s = nums.join(" to ");

					return s;
				},
				//@ts-ignore
				UpdateStringRange(s: string) {
					//@ts-ignore
					if (!s || !this.$store)
						return s;

					//@ts-ignore
					const ranges = this.$store.getters.currencyRange;
					if (ranges.length == 0)
						return s;
					else {
						s = s.trim();
						//@ts-ignore
						const i = this.usdRanges.indexOf(s);
						return ranges[i];
					}
				}
			},
			mounted() {
				Vue.prototype.$currency = {
					format: this.UpdateString,
					range: this.UpdateStringRange
				}

			}
		});
	}
}
